import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-global-line text-lg text-white"></i>
                </div>
                <span className="text-background-50 font-semibold text-lg font-heading">
                  一级免费
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed">
                精选优质免费资源，一站式免费网站导航平台。无需注册，无需付费，让每个人都能轻松发现和使用最好的免费网络资源。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">
                快捷导航
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-background-400 hover:text-background-100 text-sm transition-colors">首页</Link>
                <Link to="/categories" className="text-background-400 hover:text-background-100 text-sm transition-colors">全部分类</Link>
                <Link to="/articles" className="text-background-400 hover:text-background-100 text-sm transition-colors">精选文章</Link>
                <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">
                热门分类
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/ai-tools" className="text-background-400 hover:text-background-100 text-sm transition-colors">AI工具</Link>
                <Link to="/category/design-resources" className="text-background-400 hover:text-background-100 text-sm transition-colors">设计素材</Link>
                <Link to="/category/dev-tools" className="text-background-400 hover:text-background-100 text-sm transition-colors">开发工具</Link>
                <Link to="/category/online-tools" className="text-background-400 hover:text-background-100 text-sm transition-colors">在线工具</Link>
                <Link to="/category/learning-resources" className="text-background-400 hover:text-background-100 text-sm transition-colors">学习资源</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4 text-sm">
                关于本站
              </h4>
              <p className="text-background-400 text-sm leading-relaxed mb-4">
                我们是一支热爱分享的团队，致力于为中文互联网用户提供最全面、最优质的免费资源导航服务。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors"
              >
                了解更多
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-xs">
              &copy; {currentYear} 一级免费网站免费资源导航平台. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">使用条款</a>
              <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}